import { render } from "./Company.vue?vue&type=template&id=6fb20cb3"
import script from "./Company.vue?vue&type=script&setup=true&lang=js"
export * from "./Company.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Company.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6fb20cb3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6fb20cb3', __exports__)) {
    api.reload('6fb20cb3', __exports__)
  }
  
  module.hot.accept("./Company.vue?vue&type=template&id=6fb20cb3", () => {
    api.rerender('6fb20cb3', render)
  })

}


export default __exports__